import React from 'react';

class Dropdown extends React.Component {

  state = {
    value: this.props.value
  };

  getStyles = () => {
    return {
      container: {
        flex: 1,
        height: '45px',
        minHeight: '45px',
      },
      dropdown: {
        border: '1px solid #777',
        backgroundColor: 'white',
        borderRadius: '1px',
        appearance: 'none',
        height: '100%',
        fontSize: '16px',
        paddingLeft: '10px',
        textAlignLast: 'center',
        position: 'relative',
        color: 'black',
        width: '100%',
      },
    };
  };

  handleChange = (e) => {
    this.setState({ value: e.target.value });
    return this.props.onChange(e.target.value);
  };

  render() {
    const {
      name,
      placeholder,
      ids,
      displayedValues
    } = this.props;
    const styles = this.getStyles();
    return (
      <div style={styles.container}>
        <select
          style={styles.dropdown}
          name={name}
          value={this.state.value}
          onChange={this.handleChange}
        >
          {placeholder && (
            <option value="">{this.props.placeholder}</option>
          )}
          {ids.map((id, index) => {
            return (
              <option className="sc_dropdown_option" key={index} value={id}>
                {displayedValues[index]}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}

export default Dropdown;
